export const statuses = {
  DRAFT: 'Draft',
  PUBLISHED: 'Published'
}

Object.freeze(statuses)